import styled from 'styled-components';
import DefaultTitle from '~components/dumbs/Title';
import Text from '~components/dumbs/Text';

export const Description = styled(Text)`
  text-align: center;
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
  width: 500px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 312px;
  }
`;

export const Title = styled(DefaultTitle)`
  margin-top: ${({ theme }) => theme.spacing.km14};
`;

export const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km16};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 312px;
    height: 100%;

    & > button {
      width: 100%;
      margin-top: auto;
    }
  }
`;
